import * as React from 'react'

import { config } from '../../../common/config'
import pushHistory from '../../../common/utils/location/pushHistory'
import EmptyResultsPlaceholder from '../../components/emptyResultsPlaceholder'
import ItemsGridWithSidebar from '../../components/itemsGridWithSidebar'
import LoadingSpinnerPlaceholder from '../../components/loadingSpinnerPlaceholder'
import PageContentSection from '../../components/pageContentSection'
import PageTextHeading from '../../components/pageTextHeading'
import SearchPageContentWrapper from '../../components/searchPageContentWrapper'
import Tabs from '../../components/tabs'
import Tab from '../../components/tabs/tab'
import ThumbnailsSidebar from '../../components/thumbnailsSidebar'
import ItemsBookmarksLoaderContainer from '../../containers/itemsBookmarsLoaderContainer'

import * as styles from './topSellersPage.module.css'

import { Props } from '../../containers/topSellersPageContainer'

const TopSellersPage = (props: Props) => {
  const {
    items,
    featuredAuthors,
    location,
    experimentsReady,
    currentSite,
    isLoading,
    metadata,
    history
  } = props
  const hasItems = items && items.length > 0
  const period = location.query.period
  const defaultAvatarImgSrc = `${
    config.assets.PUBLIC_PATH
  }/images/default-user.jpg`
  const featuredAuthorsThumbnails = featuredAuthors.map(author => ({
    imgSrc: author.profile_image_url || defaultAvatarImgSrc,
    link: author.profile_path,
    title: author.username
  }))

  const onTabsChange = (value: string) => {
    pushHistory(history, `?period=${value}`)
  }

  return (
    <article>
      <ItemsBookmarksLoaderContainer items={items}>
        <PageTextHeading
          title="Top Sellers"
          subtitle={metadata && metadata.sub_heading}
        />
        <SearchPageContentWrapper experimentsReady={experimentsReady}>
          <PageContentSection withShadow>
            <div className={styles.tabs}>
              <Tabs value={period} onChange={onTabsChange}>
                <Tab value="week">This week</Tab>
                <Tab value="month">Last month</Tab>
              </Tabs>
            </div>
            {isLoading && <LoadingSpinnerPlaceholder />}
            {hasItems && (
              <ItemsGridWithSidebar
                items={items}
                location={location}
                sidebar={
                  <ThumbnailsSidebar
                    title="Featured Authors"
                    thumbnails={featuredAuthorsThumbnails}
                  />
                }
              />
            )}
            {!isLoading &&
              !hasItems && (
                <EmptyResultsPlaceholder
                  heading="Nothing exists here"
                  subHeading="We couldn't find any data for this page. Please try again later."
                />
              )}
          </PageContentSection>
        </SearchPageContentWrapper>
      </ItemsBookmarksLoaderContainer>
    </article>
  )
}

export default TopSellersPage
